/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { OrgId } from "@hex/common";
import { all, call, spawn } from "redux-saga/effects";

import { logErrorMsg } from "../util/logging";

import { hexVersionDataConnectionsSaga } from "./sagas/dataConnectionsSaga";
import { graphSaga } from "./sagas/graphSaga";
import { graphV3Saga } from "./sagas/graphV3Saga";
import { mapDatasetSaga } from "./sagas/mapDatasetSaga";
import { secretsSaga } from "./sagas/secretsSaga";
import { SagaContext } from "./sagas/types";

export function* rootSaga(orgId: OrgId, ctx: SagaContext) {
  const sagas = [
    graphSaga,
    secretsSaga,
    hexVersionDataConnectionsSaga,
    graphV3Saga,
    mapDatasetSaga,
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga, orgId, ctx);
            break;
          } catch (e) {
            logErrorMsg(e, "error in reduxs saga");
          }
        }
      }),
    ),
  );
}
